// extracted by mini-css-extract-plugin
export default {"colors":"\"~web/react/components/common/styles/colors.module.css\"","color-black":"#000000","colorBlack":"#000000","secondaryMenuHeader":"FvqsE a8cCT","menuItemBigChevron":"FCFk_"};